'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'shower';
var width = 512;
var height = 512;
var aliases = [128703];
var unicode = 'f2cc';
var svgPathData = 'M48 123.9c0-24.2 19.6-43.9 43.9-43.9 11.6 0 22.8 4.6 31 12.9l4.9 4.9C99.1 142.2 104.1 202.1 143 241l7.1 7.1c-8.4 9.4-8.1 23.9 .9 32.9 9.4 9.4 24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9-9-9-23.5-9.4-32.9-.9L305 79c-38.9-38.9-98.8-44-143.2-15.2l-4.9-4.9C139.6 41.7 116.3 32 91.9 32 41.1 32 0 73.1 0 123.9L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-332.1zM177 113c26-26 68.1-26 94.1 0l7 7-94.1 94.1-7-7c-26-26-26-68.1 0-94.1zm239 79a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faShower = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;